export default {
  USER_IS_NOT_EXIST_IN_THE_EMPLOYEES: 'Employee is not exist!',
  USER_ERROR_EMAIL_HAS_BEEN_REGISTERED: 'An email has been registered!',
  USER_IS_NOT_CONTANT_THE_PASSWORD: 'Password cannot contain the username',
};
